import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=179c81ce&scoped=true"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"
import style0 from "./Scroll.vue?vue&type=style&index=0&id=179c81ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179c81ce",
  null
  
)

export default component.exports